<template>
  <div v-if="questionKind == 'latex'">
    <LatexView :latex="question" />
  </div>
  <div v-else-if="questionKind == 'html'" v-html="question"></div>
  <div v-else-if="questionKind == 'mathml'" class="tw-text-[24px]">
    <math v-html="question"></math>
  </div>
  <div v-else-if="questionKind == 'svg'" class="tw-px-4 tw-text-center">
    <svg ref="svgtag" style="max-height: 40vh" class="tw-mx-auto">
      <g v-html="question"></g>
    </svg>
  </div>
  <div v-else>
    {{ question }}
  </div>
</template>

<script lang="ts">
import { PropType, defineComponent } from "vue";
import LatexView from "../ui/LatexView.vue";
import { SfMathLevelFormat } from "@/types/mathsTypes";

export default defineComponent({
  components: { LatexView },
  props: {
    questionKind: {
      type: String as PropType<SfMathLevelFormat>,
      required: true,
    },
    question: { type: String, required: true },
  },
  data() {
    return {};
  },
  mounted(){
    if(this.questionKind == 'svg'){
      this.autoSizeSvg();
    }
  },
  methods: {
    autoSizeSvg() {
      const svg = this.$refs.svgtag as SVGSVGElement;
      const bbox = svg.getBBox();
      svg.setAttribute("viewBox", `${bbox.x} ${bbox.y} ${bbox.width} ${bbox.height}`)
    }
  }
});
</script>
